import { Text } from '@mantine/core';

export interface AllHiddenNoticeProps {
  /** Which dashboard section is fully hidden */
  itemNoun: 'tiles' | 'charts';
}

/**
 * Single source for the "everything in this section is hidden" empty state,
 * shared by MetricTilesGrid (tiles) and ChartsPage (charts) so the copy can
 * never drift between the two.
 */
export function AllHiddenNotice({ itemNoun }: AllHiddenNoticeProps): JSX.Element {
  return (
    <Text c="dimmed" ta="center">
      All {itemNoun} are hidden — use Customize → Add to bring them back.
    </Text>
  );
}
